import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPictureInPicture: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPictureInPicture"><Path d="M9.25 17.25H5.75C4.09315 17.25 2.75 15.9069 2.75 14.25V7.75C2.75 6.09315 4.09315 4.75 5.75 4.75H16.25C17.9069 4.75 19.25 6.09315 19.25 7.75V11.25M14.75 14.75H19.25C20.3546 14.75 21.25 15.6454 21.25 16.75V18.25C21.25 19.3546 20.3546 20.25 19.25 20.25H14.75C13.6454 20.25 12.75 19.3546 12.75 18.25V16.75C12.75 15.6454 13.6454 14.75 14.75 14.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPictureInPicture;
